import { render, staticRenderFns } from "./CustomerEmailForm.vue?vue&type=template&id=25679f80&"
import script from "./CustomerEmailForm.vue?vue&type=script&lang=js&"
export * from "./CustomerEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports